import { render, staticRenderFns } from "./GameOverOverlay.vue?vue&type=template&id=58380f1d&"
import script from "./GameOverOverlay.vue?vue&type=script&lang=ts&"
export * from "./GameOverOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./GameOverOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports